import StreamType from '../types/enums/stream';

const StreamUtils = {
  checkStreamType(asset: string | undefined, type: StreamType) {
    if (!asset) {
      return '';
    }
    if (asset.indexOf('.mpd') > -1 && type === StreamType.DASH) {
      return asset;
    }
    if (asset.indexOf('.m3u8') > -1 && type === StreamType.HLS) {
      return asset;
    }
    return '';
  },
  getStreamingProtocol(asset: string | undefined) {
    if (!asset) {
      return '';
    }
    if (asset.indexOf('.mpd') > -1) {
      return "DASH";
    }else {
      return "HLS"
    }
  },
};

export default StreamUtils;
